var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42878 6.32141C3.13291 6.32141 2.89307 6.56126 2.89307 6.85713C2.89307 7.15299 3.13291 7.39284 3.42878 7.39284C3.72465 7.39284 3.9645 7.15299 3.9645 6.85713C3.9645 6.56126 3.72465 6.32141 3.42878 6.32141ZM1.39307 6.85713C1.39307 5.73283 2.30449 4.82141 3.42878 4.82141C4.55307 4.82141 5.4645 5.73283 5.4645 6.85713C5.4645 7.98142 4.55307 8.89284 3.42878 8.89284C2.30449 8.89284 1.39307 7.98142 1.39307 6.85713Z",
    fill: "#67C2E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42878 11.4642C3.13291 11.4642 2.89307 11.7041 2.89307 11.9999C2.89307 12.2958 3.13291 12.5357 3.42878 12.5357C3.72465 12.5357 3.9645 12.2958 3.9645 11.9999C3.9645 11.7041 3.72465 11.4642 3.42878 11.4642ZM1.39307 11.9999C1.39307 10.8757 2.30449 9.96423 3.42878 9.96423C4.55307 9.96423 5.4645 10.8757 5.4645 11.9999C5.4645 13.1242 4.55307 14.0357 3.42878 14.0357C2.30449 14.0357 1.39307 13.1242 1.39307 11.9999Z",
    fill: "#67C2E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42878 16.6072C3.13291 16.6072 2.89307 16.847 2.89307 17.1429C2.89307 17.4388 3.13291 17.6786 3.42878 17.6786C3.72465 17.6786 3.9645 17.4388 3.9645 17.1429C3.9645 16.847 3.72465 16.6072 3.42878 16.6072ZM1.39307 17.1429C1.39307 16.0186 2.30449 15.1072 3.42878 15.1072C4.55307 15.1072 5.4645 16.0186 5.4645 17.1429C5.4645 18.2672 4.55307 19.1786 3.42878 19.1786C2.30449 19.1786 1.39307 18.2672 1.39307 17.1429Z",
    fill: "#67C2E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53613 6.85718C6.53613 6.44296 6.87192 6.10718 7.28613 6.10718H21.8576C22.2718 6.10718 22.6076 6.44296 22.6076 6.85718C22.6076 7.27139 22.2718 7.60718 21.8576 7.60718H7.28613C6.87192 7.60718 6.53613 7.27139 6.53613 6.85718Z",
    fill: "#265EA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24316 4.82141C7.65738 4.82141 7.99316 5.1572 7.99316 5.57141V8.14284C7.99316 8.55705 7.65738 8.89284 7.24316 8.89284C6.82895 8.89284 6.49316 8.55705 6.49316 8.14284V5.57141C6.49316 5.1572 6.82895 4.82141 7.24316 4.82141Z",
    fill: "#265EA7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53613 12C6.53613 11.5858 6.87192 11.25 7.28613 11.25H21.8576C22.2718 11.25 22.6076 11.5858 22.6076 12C22.6076 12.4142 22.2718 12.75 21.8576 12.75H7.28613C6.87192 12.75 6.53613 12.4142 6.53613 12Z",
    fill: "#265EA7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24316 9.96423C7.65738 9.96423 7.99316 10.3 7.99316 10.7142V13.2857C7.99316 13.6999 7.65738 14.0357 7.24316 14.0357C6.82895 14.0357 6.49316 13.6999 6.49316 13.2857V10.7142C6.49316 10.3 6.82895 9.96423 7.24316 9.96423Z",
    fill: "#265EA7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53613 17.1429C6.53613 16.7287 6.87192 16.3929 7.28613 16.3929H21.8576C22.2718 16.3929 22.6076 16.7287 22.6076 17.1429C22.6076 17.5572 22.2718 17.8929 21.8576 17.8929H7.28613C6.87192 17.8929 6.53613 17.5572 6.53613 17.1429Z",
    fill: "#265EA7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24316 15.1072C7.65738 15.1072 7.99316 15.443 7.99316 15.8572V18.4286C7.99316 18.8428 7.65738 19.1786 7.24316 19.1786C6.82895 19.1786 6.49316 18.8428 6.49316 18.4286V15.8572C6.49316 15.443 6.82895 15.1072 7.24316 15.1072Z",
    fill: "#265EA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.834a01b4cdec8a9aa8e8d8859c4f9542.svg";
export { ForwardRef as ReactComponent };